import * as ACTION from 'actions'

export function project(state={id: null, name: null, displayName: null, languageCode: null}, action) {
    switch (action.type) {
        case ACTION.FIND_PROJECT:
            return action.project;
        case ACTION.EDIT_PROJECT:
            return action.project;
        default:
            return state;
    }
}

export function projects(state=[], action) {
    if(action == null) return  state;

    switch (action.type) {
        case ACTION.FETCH_PROJECTS:
            return action.projects;
        case ACTION.ADD_PROJECT:
            return [
                ...state,
                action.project
            ];
        default:
            return state
    }
}